module.exports = __webpack_public_path__ + "static/media/documentHeader.f908d316.jpg";